import { useEffect, useRef, useState } from "react";
import { canv } from "@/canv/global";

type EditableTitleInputProps = {
    initialValue: string;
    onSubmit: (value: string) => void;
    onCancel: () => void;
};

export const EditableTitleInput = ({
    initialValue,
    onSubmit,
    onCancel,
}: EditableTitleInputProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        inputRef.current?.focus();
        return () => {
            canv.appInterface.inputFocused = 0;
        };
    }, []);

    const finish = () => {
        canv.appInterface.inputFocused = 0;
        if (canv.isBoardModeEditOrOwner()) {
            onSubmit(value);
        } else {
            onCancel();
        }
    };

    const cancel = () => {
        canv.appInterface.inputFocused = 0;
        setValue(initialValue);
        onCancel();
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" || e.key === "Tab") {
            e.preventDefault();
            finish();
        }

        if (e.key === "Escape") {
            e.preventDefault();
            cancel();
        }
    };

    const handleFocus = () => {
        canv.appInterface.inputFocused = 1;
    };

    const handleBlur = () => {
        canv.appInterface.inputFocused = 0;
        finish();
    };

    return (
        <input
            ref={inputRef}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onClick={(e) => e.stopPropagation()}
            onFocus={handleFocus}
            onBlur={handleBlur}
        />
    );
};
